import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import ShopLayout from "./../../layouts/ShopLayout/ShopLayout";
import DashboardShop from "../../pages/Shop/DashboardShop/DashboardShop";
import DashboardShopContext from "../../context/ShopContext/DashboardShopContext/DashboardShopContext";
import ProfileUser from "./../../pages/User/ProfileUser/ProfileUser";
import ProfileUserContext from "../../context/UserContext/ProfileUserContext/ProfileUserContext";
import TicketsUser from "../../pages/User/TicketsUser/TicketsUser";
import TicketUserContext from "../../context/UserContext/TicketUserContext/TicketUserContext";
import TransactionsUser from "../../pages/User/TransactionsUser/TransactionsUser";
import TransactionUserContext from "../../context/UserContext/TransactionUserContext/TransactionUserContext";
import InfoShop from "../../pages/Shop/InfoShop/InfoShop";
import InfoShopContext from "../../context/ShopContext/InfoShopContext/InfoShopContext";
import QrCodeScannerShop from "../../pages/Shop/QrCodeScannerShop/QrCodeScannerShop";
import QrCodeScannerShopContext from "../../context/ShopContext/QrCodeScannerShopContext/QrCodeScannerShopContext";
import NotFoundPage from "../../pages/Page/NotFoundPage/NotFoundPage";
import NotificationsUser from "./../../pages/User/NotificationsUser/NotificationsUser";
import NotificationUserContext from "../../context/UserContext/NotificationUserContext/NotificationUserContext";
import ShopOrdersUser from './../../pages/User/ShopOrdersUser/ShopOrdersUser';
import ShopOrderUserContext from "../../context/UserContext/ShopOrderUserContext/ShopOrderUserContext";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems } from "../../utils/enum";

const ShopContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[4])
    return <Navigate to="/" replace />;

  return (
    <ShopLayout>
      <Routes>
        {/* Dashboard */}
        <Route
          index
          element={
            <DashboardShopContext>
              <DashboardShop />
            </DashboardShopContext>
          }
        />

        {/* Profile */}
        <Route
          path="/profile"
          element={
            <ProfileUserContext>
              <ProfileUser />
            </ProfileUserContext>
          }
        />

        {/* Qr Code Scanner */}
        <Route
          path="/qr-code-scanner"
          element={
            <QrCodeScannerShopContext>
              <QrCodeScannerShop />
            </QrCodeScannerShopContext>
          }
        />

        {/* Info */}
        <Route
          path="/info"
          element={
            <InfoShopContext>
              <InfoShop />
            </InfoShopContext>
          }
        />

        {/* Tickets */}
        <Route
          path="/tickets"
          element={
            <TicketUserContext>
              <TicketsUser />
            </TicketUserContext>
          }
        />

        {/* Transactions */}
        {["/transactions", "/transactions/:user/user"].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <TransactionUserContext>
                <TransactionsUser />
              </TransactionUserContext>
            }
          />
        ))}

        {/* Shop Orders */}
        <Route
          path="/shop-orders"
          element={
            <ShopOrderUserContext>
              <ShopOrdersUser />
            </ShopOrderUserContext>
          }
        />

        {/* Notifications */}
        <Route
          path="/notifications"
          element={
            <NotificationUserContext>
              <NotificationsUser />
            </NotificationUserContext>
          }
        />

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ShopLayout>
  );
};

export default ShopContainer;
